import whatIsLoriiniTest from "../../translations/pl_PL/blog/whatIsLoriiniTest.json";
import { PUT_DATA_BLOG } from '../Blog/action';

function whatIsLoriiniTestReducer(state = whatIsLoriiniTest, action) {
  switch (action.type) {
    case PUT_DATA_BLOG:
      {
        if (action.meta === "whatIsLoriiniTest") {
          return action.payload;
        } else { 
          return state }
      }

    default:
      return state;
  }
}

export default whatIsLoriiniTestReducer;
